import React from 'react';

export const ErrorIllustration = () => (
  <svg
    width="318"
    height="159"
    viewBox="0 0 318 159"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <g clipPath="url(#clip0_2733_100375)">
      <path
        d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
        fill="#BEEFF3"
      />
      <mask
        id="mask0_2733_100375"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="74"
        y="36"
        width="166"
        height="123"
      >
        <path d="M74 36h166v123H74V36Z" fill="#FF0000" />
      </mask>
      <g mask="url(#mask0_2733_100375)">
        <mask
          id="mask1_2733_100375"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="318"
          height="159"
        >
          <path
            d="M0 158.64C0 71.03 71.03 0 158.64 0c87.61 0 158.64 71.03 158.64 158.64H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_2733_100375)">
          <path
            d="M208.36 83.1c0 .07-.01.13-.02.2-.23 2.1-1.12 4.32-1.08 6.42-.19 1.48 2.26 3.12 5.53 3.68 3.28.56 6.15-.17 6.45-1.64v-.03l1.45-8.56c.07-.39.79-1.06 1.03-1.39.44-.61.86-1.22 1.24-1.87.79-1.34 1.43-2.76 1.93-4.23.8-2.39 1.2-4.92 1.16-7.44-.04-2.26-1.37-3.34-3.58-3.69-4.65-.75-9.17 1.19-13.68 1.63-1.35.13-2.83.83-3.15 2.16-.14.58-.03 1.18.1 1.76 1.02 4.43 3.08 8.36 2.63 13.01l-.01-.01Z"
            fill="#994D1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m224.476 91.53-8.34 26.199a10.48 10.48 0 0 1-11.298 7.219l-42.64-5.38 2.624-20.795 33.987 4.288 5.695-17.89 19.972 6.358Z"
            fill="#DFA414"
          />
          <path
            d="M164.61 79.86c6.39 0 11.57-5.18 11.57-11.57 0-6.39-5.18-11.57-11.57-11.57-6.39 0-11.57 5.18-11.57 11.57 0 6.39 5.18 11.57 11.57 11.57Z"
            fill="#302725"
          />
          <path
            d="M149.94 66.67a7.71 7.71 0 1 0 0-15.42 7.71 7.71 0 0 0 0 15.42Z"
            fill="#582917"
          />
          <path
            d="M157.06 54.81c1.42.71 3.42 1.04 4.98.97 3.06-.14 5.95-.28 9.06-.19 4.61.13 9.14-1.07 13.59-2.26-4.22-7.59-12.31-12.9-20.96-13.74-13-1.26-25.56 6.91-38.55 5.54-5.54-.58-10.72-2.87-16.01-4.61-9.76-3.2-21.09-3.28-28.43 4.79-7.82 8.6-3.99 18.85 4.31 25.49 0 0-4 15.99 15.99 16 1.38 0-3.99 12 16.01 12 3.31 0 4.72-.39 8 0 5.09.61 1.39-4.39 6.35-5.7 6.49-1.71 19.55-5.04 22.08-12.34.98-2.83.84-6.87 1.27-9.86.77-5.37 1.53-10.74 2.3-16.1l.01.01Z"
            fill="#072462"
          />
          <path
            d="M193.027 66.926c.422-9.297-9.089-17.28-21.243-17.832-12.154-.552-22.349 6.537-22.772 15.833-.422 9.296 9.089 17.28 21.243 17.832 12.155.552 22.35-6.537 22.772-15.833Z"
            fill="#AD6E36"
          />
          <path
            d="m155.71 69.57 14.15 8.96-16.7 25.01c-1.05 1.61-4.79 1.08-8.38-1.19-3.59-2.27 1.88-17.22 2.89-18.86l-7.55 11.79 15.59-25.71Z"
            fill="#AD6E36"
          />
          <path
            d="M175.13 66.73a1.26 1.26 0 1 0 0-2.52 1.26 1.26 0 0 0 0 2.52ZM186.58 65.63a1.26 1.26 0 1 0 0-2.52 1.26 1.26 0 0 0 0 2.52ZM178.54 76.13c-2.26.49-4.73-.29-5.51-2.62-.18-.55-1.05-.31-.87.24.95 2.82 3.85 3.85 6.62 3.25.57-.12.33-.99-.24-.87Z"
            fill="#582917"
          />
          <path
            d="m168.629 61.549 5.357-2.198a1.38 1.38 0 0 0 .752-1.8l-.026-.065a1.38 1.38 0 0 0-1.801-.753l-5.356 2.198a1.38 1.38 0 0 0-.753 1.8l.026.065a1.38 1.38 0 0 0 1.801.753ZM184.651 58.92l5.892 2.143a1.38 1.38 0 0 0 1.769-.825l.024-.066a1.38 1.38 0 0 0-.826-1.768l-5.892-2.143a1.38 1.38 0 0 0-1.769.825l-.024.066a1.38 1.38 0 0 0 .826 1.769Z"
            fill="#072462"
          />
          <path
            d="M167.35 72.12a2.7 2.7 0 1 0 0-5.4 2.7 2.7 0 0 0 0 5.4ZM180.76 72.61l4.64-3.31c.64-.46.68-1.4.07-1.91l-6.66-5.59 1.95 10.8v.01Z"
            fill="#9A4D1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M159.887 79.119a.5.5 0 0 1 .704-.062c1.204 1.01 2.758 1.713 4.034 2.165a19.62 19.62 0 0 0 2.052.603l.122.026.03.007.007.001h.001a.5.5 0 0 1-.194.981l.097-.49-.097.49h-.005l-.01-.002-.036-.008a15.658 15.658 0 0 1-.632-.151 20.548 20.548 0 0 1-1.67-.514c-1.324-.47-3.005-1.222-4.341-2.342a.5.5 0 0 1-.062-.704Z"
            fill="#9A4D1D"
          />
          <path
            d="M150.44 66.55a7.01 7.01 0 1 0 0-14.02 7.01 7.01 0 0 0 0 14.02Z"
            fill="#AD6E36"
          />
          <path
            d="M147.39 58.91c.68-.33 1.35-.66 2.03-.99.29-.14.61-.35.93-.42.26-.06.36.12.37.36.03.61-.36 1.2-.56 1.76-.18.5-.24 1.04-.04 1.55.2.51.64.97 1.24.92.41-.03.42-.68 0-.65-.44.03-.66-.42-.71-.8-.08-.59.27-1.16.48-1.68.21-.52.4-1.22.06-1.73-.44-.66-1.22-.28-1.77-.02-.78.38-1.57.76-2.35 1.14-.38.18-.05.74.33.56h-.01Z"
            fill="#9A4D1D"
          />
          <path
            d="M91.32 186.83c-.18.59.42 1.17.67 1.75 24.27 1.6 49.05.15 73.38.15l5-53.4s2.23-20.79-3.01-36.47c-3.45-10.33-14.94-14.41-22.93-11.95-14.67 4.53-20.89 8.51-25.4 22.49-3.5 10.85-5.57 22.14-9.67 32.78-2.71 7.02-6.09 16.19-8.3 23.38-2.02 6.59-6.45 10.67-9.74 21.27Z"
            fill="#FDC221"
          />
          <path
            d="m162.07 102.59-23.3-6.85 6.91-10.93 19.03 5.05-2.64 12.73Z"
            fill="#FDC221"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m146.742 89.78 15.31 3.18-.204.98-15.31-3.18.204-.98ZM157.924 117.842l11.56 7.58-.548.836-11.56-7.58.548-.836Z"
            fill="#DFA414"
          />
          <path
            d="M185.28 46.37c-7.77-6.66-16.92-8.53-26.75-6.97-4.81.76-9.82 2.24-13.99 4.81-1.63 1.01-2.71 1.83-4.52 2.47-2.32.82-4.33 2.13-6.68 2.9-2.73.89-4.98 2.66-7.23 4.41-1.33 1.03-2.76 2.51-2.32 4.13 6.59-.54 13.22-.03 19.83-.19a7.01 7.01 0 0 1 5.7-5.31c2.15-.35 4.49.34 6.02 1.91 1.48 1.52 2.07 3.38 4.21 4.3 1.53-2.22 2.87-4.57 4-7.02.42 1.73.85 3.45 1.27 5.18 8-2.34 17.29-2.02 25.36.08 0-1.61-1.09-7.45-4.9-10.71v.01Z"
            fill="#072462"
          />
          <path
            d="M234.34 59.12c0-.64-1.02-1.12-1.49-1.09l-36.12 2.53c-.27.02-.49.33-.49.7l-.08 9.23c0 .36.2.65.47.66l36.23 1.01c.47.01 1.35-.51 1.36-1.16l.13-11.88h-.01Z"
            fill="#E60278"
          />
          <path
            d="M213.2 61.33c1.049 0 1.9-1.12 1.9-2.5s-.851-2.5-1.9-2.5-1.9 1.12-1.9 2.5.851 2.5 1.9 2.5ZM217 60.87c1.049 0 1.9-1.12 1.9-2.5s-.851-2.5-1.9-2.5-1.9 1.12-1.9 2.5.851 2.5 1.9 2.5Z"
            fill="#994D1D"
          />
          <path
            d="M220.37 61.17c1.049 0 1.9-1.12 1.9-2.5s-.851-2.5-1.9-2.5-1.9 1.12-1.9 2.5.851 2.5 1.9 2.5Z"
            fill="#994D1D"
          />
          <path
            d="M223.57 61.49c1.049 0 1.9-1.12 1.9-2.5s-.851-2.5-1.9-2.5-1.9 1.12-1.9 2.5.851 2.5 1.9 2.5Z"
            fill="#994D1D"
          />
          <path
            d="M232.85 72.16c3.198 0 5.79-3.16 5.79-7.06 0-3.9-2.592-7.06-5.79-7.06s-5.79 3.16-5.79 7.06c0 3.9 2.592 7.06 5.79 7.06Z"
            fill="#F8B1DC"
          />
          <path
            d="m220.37 58.37-32.67 2.31c-2.96 0-5.35 2.84-5.35 6.35s2.4 6.35 5.35 6.35l32.67 1c.54.02 1.53-.58 1.54-1.31l.15-13.46c0-.72-1.16-1.27-1.69-1.23v-.01Z"
            fill="#EE399E"
          />
          <path
            d="M220.37 74.37c3.618 0 6.55-3.582 6.55-8s-2.932-8-6.55-8c-3.617 0-6.55 3.582-6.55 8s2.933 8 6.55 8Z"
            fill="#F8B1DC"
          />
          <path
            d="M199.84 57.97c-1.52 1.16-3.57 4.9-4.69 7.38-1.21 2.68-2.93 5.68-3.4 8.62-.83 5.24-.05 12.76.36 18.64l-.18 6.71c.02 1.49 2.68 2.77 5.99 2.86 3.33.1 6.07-1.04 6.15-2.53v-.03l.24-8.68c1.23-2.2 3.34-6.49 1.17-13.79 1.05-2.49 2.28-4.84 3.37-7.58.67-1.66 1.1-5.1-.52-5.53.99-2.52 1.7-3.52.16-5.06-.49-.5-1.48-.61-1.94-.21-.25-1.52-2.43-1.94-4.07-.3.43-.43-.18-.91-.57-.92-.79-.02-1.55.02-2.08.43l.01-.01Z"
            fill="#AE6E35"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M207.962 63.718a.5.5 0 0 1 .18.684l-4.68 8.01a.5.5 0 0 1-.864-.504l4.68-8.01a.5.5 0 0 1 .684-.18ZM206.462 58.904a.54.54 0 0 1 .194.739l-6.93 11.86a.54.54 0 1 1-.932-.545l6.93-11.86a.54.54 0 0 1 .738-.194ZM202.613 58.558a.5.5 0 0 1 .178.685l-6.2 10.58a.5.5 0 1 1-.862-.506l6.2-10.58a.5.5 0 0 1 .684-.179Z"
            fill="#994D1D"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m207.384 93.66-6.39 36.65a10.48 10.48 0 0 1-14.656 7.743l-43.44-19.72 8.664-19.086 31.11 14.123 4.064-23.31 20.648 3.6Z"
            fill="#FDC221"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m170.932 131.579-29.82-12.86.396-.918 29.82 12.86-.396.918ZM181.443 112.749l-22.53-9.65.394-.919 22.53 9.65-.394.919Z"
            fill="#DFA414"
          />
        </g>
      </g>
      <path
        d="M283.65 78.91c-.92.01-1.8.21-2.6.56-1.85-8.1-9.16-14.1-17.8-13.97-9.93.15-17.86 8.32-17.71 18.25.01.85.09 1.68.21 2.5l31.23-.47 4.38-.07 9.16-.14a6.776 6.776 0 0 0-6.87-6.67v.01ZM23.35 134.91c.27 0 .54.02.8.04.9-13.16 11.83-23.56 25.22-23.59 11.38-.02 21.02 7.45 24.25 17.77 1.31-.45 2.72-.7 4.18-.71 7.21-.02 13.06 5.81 13.08 13.02 0 .98-.11 1.94-.32 2.86l-16.97.04-8.48.02-32.2.07-7.62.02-11.47.02c-.01-5.27 4.25-9.55 9.52-9.56h.01Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2733_100375">
        <rect width="318" height="159" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
